import React, { useState, useContext, useEffect } from "react";
import "../../../styles/casedetails.css";
import { Outlet, Link, useNavigate, Navigate } from "react-router-dom";
import { ShareContext } from "../../../context/ShareContext";
import * as Constants from "../../../constants";
import JisButton from "../../controls/jisButton";
function ViewComments({ caseId, comments = null, isAction = false }) {
  const { activePage, token, profile, frequentData } = useContext(ShareContext);
  const [loading, setLoading] = useState(false);
  const [_comments, setComments] = useState(comments);

  console.log(comments);
  return (
    <div>
      <div className="table-header">
        <p>Comments </p>
      </div>
      <div className="table-wrapper">
        <table class="case-details-table full-border">
          <thead>
            <tr>
              <th className="col-title">Comment</th>
              <th>Comment By</th>
            </tr>
          </thead>
          <tbody>
            {comments?.map((opt) => (
              <tr key={opt.id}>
                <td>{opt.source || "N/A"}</td>
                <td>
                  {opt.profile.firstName || opt.profile.lastName
                    ? `${opt.profile.firstName} ${opt.profile.lastName ?? ""}`
                    : "N/A"}
                  {/* {opt.profile.firstName} {opt.profile.lastName ?? ""} */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* <div class="timeline-container">
        <div class="comment-count">{comments?.length} Comments</div>
        <div class="timeline-wrapper">
          <div class="vertical-line"></div>
          <div class="comment-timeline">
            {comments?.map((opt) => (
              <div class="comment-entry">
                <div class="comment-meta">
                  <div>
                    {Constants.momentDate(opt.createdDate).format("hh:mm A")}
                  </div>
                  <div>
                    {Constants.momentDate(opt.createdDate).format(
                      "DD MMM, YYYY"
                    )}
                  </div>
                </div>

                <div class="comment-box">
                  <div class="comment-text">{opt.comment}</div>
                  <div class="comment-footer">
                    <span>Source: {opt.source}</span>
                    <span>
                      {opt.profile.firstName} {opt.profile.lastName ?? ""}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default ViewComments;
